
import { 
    GET_ROLES_DONE, GET_ROLES_INIT, GET_ROLES_FAILED,
    SET_CURRENT_ROLE, UNSET_CURRENT_ROLE,
    ADD_ROLE_DONE, ADD_ROLE_INIT, ADD_ROLE_FAILED,
    DELETE_ROLE_DONE, DELETE_ROLE_FAILED, DELETE_ROLE_INIT,
    UPDATE_ROLE_DONE, UPDATE_ROLE_FAILED, UPDATE_ROLE_INIT
} from '../actions'
import pick from 'lodash/pick'
import currentRole from './currentRole'
import { combineReducers } from 'redux'


const initState = {
    byId: {},
    loading: false,
    error: null,
    current: null,
    shouldFetchRoles: true
}

const data = (state = initState, action) => {
    switch(action.type) {
        case GET_ROLES_INIT: 
            return { ...state, loading: true }
        case GET_ROLES_DONE: {
            const byId = action.payload.map((d) => {
                d.permissionsData = d.permissions
                d.permissions = d.permissionsData.filter(p => p.enabled).map(p => p.code)
                d.errors = { name: '', description: '' }
                d.name = d.name || ''
                d.description = d.description || ''
                return d
            }).reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {})
            return {  ...state, byId, loading: false, error: null, shouldFetchRoles: false }
        }
        case GET_ROLES_FAILED: 
            return {  ...state, loading: false, error: action.payload }
        case SET_CURRENT_ROLE: {
            return { ...state, current: action.payload }
        }
        case UNSET_CURRENT_ROLE:
            return { ...state, current: null}
        case DELETE_ROLE_INIT:
        case ADD_ROLE_INIT: 
        case UPDATE_ROLE_INIT:
            return { ...state, loading: true }
        case ADD_ROLE_FAILED:
        case DELETE_ROLE_FAILED:
        case UPDATE_ROLE_FAILED:
            return { ...state, loading: false }
        case ADD_ROLE_DONE: 
            return { 
                ...state, 
                byId: { ...state.byId, [action.payload.id]: action.payload }, 
                loading: false,
                current: action.payload.id,
                shouldFetchRoles: true
            }
        case DELETE_ROLE_DONE: {
            const filteredOut = Object.values(state.byId).filter(d => d.id != action.payload).map(d => d.id)
            const byId = pick(state.byId, filteredOut)
            return { ...state, byId, loading: false, shouldFetchRoles: true }
        }
        case UPDATE_ROLE_DONE: {
            const byId = { ...state.byId, [action.payload.id]: action.payload }
            return { ...state, byId, loading: false, shouldFetchRoles: true }
        }   
        default: 
            return state
    }

}

export default combineReducers({
    data,
    currentRole
})